import type { SupportedLocale as Lang, NewsItem } from "@site-types/site"
import type { CSSProperties } from "react"
import { imageDimensions, imageSizes, imageSrcSet, imageUrl } from "../../componentUtils"
import "./styles.css"

export function NewsCard({
  post,
  detail = false,
  priority = false,
}: {
  locale: Lang
  post: NewsItem
  detail?: boolean
  priority?: boolean
}) {
  if (!post.newsCoverImage) return null
  const transitionName = `news-${post.slug?.current}`
  const transitionStyle = { viewTransitionName: transitionName } as CSSProperties
  const imagePreset = detail ? "newsDetail" : "newsCard"
  const isPriority = detail || priority
  const image = (
    <img
      src={imageUrl(post.newsCoverImage, imagePreset)}
      srcSet={imageSrcSet(post.newsCoverImage, imagePreset)}
      sizes={imageSizes(imagePreset)}
      alt={post.title ?? ""}
      loading={isPriority ? "eager" : "lazy"}
      decoding="async"
      fetchPriority={isPriority ? "high" : "auto"}
      {...imageDimensions(post.newsCoverImage)}
    />
  )

  if (detail) {
    return (
      <div
        className="news-card-detail"
        data-content-transition-name={transitionName}
        data-content-transition-element="true"
        data-news-transition-name={transitionName}
        data-news-transition-element="true"
        style={transitionStyle}
      >
        {image}
      </div>
    )
  }
  return (
    <div
      className="news-card"
      data-content-transition-name={transitionName}
      data-content-transition-element="true"
      data-news-transition-name={transitionName}
      data-news-transition-element="true"
    >
      {image}
    </div>
  )
}

export default NewsCard
